import { render, staticRenderFns } from "./FooterButtons.vue?vue&type=template&id=337de8e1&scoped=true&"
import script from "./FooterButtons.vue?vue&type=script&lang=js&"
export * from "./FooterButtons.vue?vue&type=script&lang=js&"
import style0 from "./FooterButtons.vue?vue&type=style&index=0&id=337de8e1&scoped=true&lang=css&"
import style1 from "./FooterButtons.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337de8e1",
  null
  
)

export default component.exports